interface envConfigInterface {
  baseApi: string,
  baseApiDatart: string,
  datartUrl: string,
  apiKey: string,
  apiKeyDatart: string,
  env: string,
  guidUrl: string,// 新手引导
  backgroundUrl: string,// 后台管理地址
  configUrl: string,// 自助分析配置
  dbaDetailUrl: string,// DBA 打开的 itsm工单链接
}
const envMap: { [key: string]: envConfigInterface } = {
  dev: {
    baseApi: 'http://yapi.longfor.com/mock/10436',
    baseApiDatart: 'https://gateway-uat.longfor.com/datart',
    apiKeyDatart: 'd64c9694-412b-4c72-a2da-bb119072e95f',
    datartUrl: 'https://datart-uat.longfor.com',
    apiKey: 'e78ff010-f8f2-4879-972a-8996a33628af',
    env: 'dev',
    guidUrl: 'https://wyys-uat.longfor.com/index/manual/p/date20220107151055.html',
    backgroundUrl: 'https://apportal-uat.longfor.com:9180/manage/1/project/list',
    configUrl: 'https://edata-uat.longfor.com/dash/dataModel/91',
    dbaDetailUrl: 'https://itsm4-uat.longfor.com/_apppage/index.html#/pages/login/idmlogin?detail=workOrderId&viewType=workDetail',
  },
  sit: {
    baseApi: 'https://api-sit.longfor.com/sdc-sit',
    baseApiDatart: 'https://api-sit.longfor.com/sdc-sit',
    apiKeyDatart: 'd64c9694-412b-4c72-a2da-bb119072e95f',
    datartUrl: 'https://datart-uat.longfor.com',
    apiKey: 'e78ff010-f8f2-4879-972a-8996a33628af',
    env: 'sit',
    guidUrl: 'https://wyys-uat.longfor.com/index/manual/p/date20220107151055.html',
    backgroundUrl: 'https://apportal-uat.longfor.com:9180/manage/1/project/list',
    configUrl: 'https://edata-uat.longfor.com/dash/dataModel/91',
    dbaDetailUrl: 'https://itsm4-uat.longfor.com/_apppage/index.html#/pages/login/idmlogin?detail=workOrderId&viewType=workDetail',
  },
  uat: {
    baseApi: 'https://gateway-uat.longfor.com/idata-uat',
    baseApiDatart: 'https://gateway-uat.longfor.com/datart',
    datartUrl: 'https://datart-uat.longfor.com',
    apiKey: 'a038cc7f-cda9-4bc4-9e75-1753a07d6eb8',
    apiKeyDatart: 'd64c9694-412b-4c72-a2da-bb119072e95f',
    env: 'uat',
    guidUrl: 'https://wyys-uat.longfor.com/index/manual/p/date20220107151055.html',
    backgroundUrl: 'https://apportal-uat.longfor.com:9180/manage/1/project/list',
    configUrl: 'https://edata-uat.longfor.com/dash/dataModel/91',
    dbaDetailUrl: 'https://itsm4-uat.longfor.com/_apppage/index.html#/pages/login/idmlogin?detail=workOrderId&viewType=workDetail',
  },
  pre: {
    baseApi: 'https://gateway-pre.longfor.com/idata-pre',
    baseApiDatart: 'https://gateway.longfor.com/datart',
    apiKeyDatart: 'd64c9694-412b-4c72-a2da-bb119072e95f',
    datartUrl: 'https://datart.longfor.com',
    apiKey: '48e28161-c424-4868-8c5d-6862a4ebe8e9',
    env: 'pre',
    guidUrl: 'https://wyys-uat.longfor.com/index/manual/p/date20220107151055.html',
    backgroundUrl: 'https://apportal-uat.longfor.com:9180/manage/1/project/list',
    configUrl: 'https://edata-uat.longfor.com/dash/dataModel/91',
    dbaDetailUrl: 'https://itsm4-uat.longfor.com/_apppage/index.html#/pages/login/idmlogin?detail=workOrderId&viewType=workDetail',
  },
  prod: {
    // baseApi: 'https://gateway.longfor.com/idata-prod',
    baseApi: 'https://gwp0.longfor.com/idata-prod',
    baseApiDatart: 'https://gateway.longfor.com/datart',
    apiKeyDatart: 'd64c9694-412b-4c72-a2da-bb119072e95f',
    datartUrl: 'https://datart.longfor.com',
    apiKey: 'f141b6bb-bc15-4bbb-844b-49a6b1c68db6',
    env: 'prod',
    guidUrl: 'https://wyys.longfor.com/index/manual/p/1NewReport.html',
    backgroundUrl: 'https://apportal.longfor.com:9000/manage/1/project/list',
    configUrl: 'https://wyys.longfor.com/dash/dataModel/386',
    dbaDetailUrl: 'https://itsm4.longfor.com/_apppage/index.html#/pages/login/idmlogin?detail=workOrderId&viewType=workDetail',
  },
};

let env = 'dev';
const { hostname } = window.location;
switch (hostname) {
  case 'idata-sit.longfor.com':
    env = 'sit';
    break;
  case 'idata-uat.longfor.com':
    env = 'uat';
    break;
  case 'idata-pre.longfor.com':
    env = 'pre';
    break;
  case 'idata.longfor.com':
    env = 'prod';
    break;
  default:
    env = 'dev';
}

export default envMap[env];
